import { Font } from "@react-pdf/renderer";

// ponytail: react-pdf v1's Font.load() returns immediately when a font fetch is
// already in flight (`if (!font.data && !font.loading)`), so a second render that
// starts inside that window lays out with `font.data === undefined` and throws —
// PDFViewer then latches state.error and the iframe stays blank for good. Each page
// mounts a preview plus one or two PDFDownloadLinks, all rendering at once, so this
// fired whenever the fonts weren't already cached. Load them once, share the promise,
// and render no PDF until it resolves.
const FAMILIES = ["proxima-nova-regular", "proxima-nova-bold"];

let pending;

const loadPDFFonts = () =>
  (pending =
    pending ||
    Promise.all(FAMILIES.map((fontFamily) => Font.load({ fontFamily }))));

export default loadPDFFonts;
